<template>
  <v-select
    :value="value"
    :items="categoryItems"
    label="Categoria"
    dense
    outlined
    clearable
    :loading="loading"
    :disabled="disabled"
    @change="onCategoryChange"
  />
</template>

<script>
import CASH from "@/services/ultimate/cash.js";
import CASH_DEFINITIONS from "@/definitions/CashDefinitions";

export default {
  name: "CashCategoryField",
  props: {
    value: {
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    companyId: {
      default: null,
    },
    selected: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      categories: [],
      loading: false,
    };
  },
  computed: {
    scope() {
      return this.companyId || "ULTIMATE";
    },
    categoryItems() {
      const items = this.categories
        .filter(
          (category) =>
            this.isCompatible(category) || category.id === this.value
        )
        .map((category) => ({
          text:
            category.active === false
              ? `${category.name} (inativa)`
              : category.name,
          value: category.id,
        }));

      if (
        this.selected &&
        this.value === this.selected.id &&
        !items.some((item) => item.value === this.selected.id)
      ) {
        items.unshift({
          text:
            this.selected.active === false
              ? `${this.selected.name} (inativa)`
              : this.selected.name,
          value: this.selected.id,
        });
      }

      return items;
    },
  },
  watch: {
    type() {
      if (this.value && !this.valueIsCompatible()) {
        this.$emit("input", null);
      }
    },
    companyId() {
      this.$emit("input", null);
      this.load();
    },
  },
  methods: {
    lineOf(category) {
      if (!category) return null;
      return CASH_DEFINITIONS.dreLines.find(
        (line) => line.value === category.dreLine
      );
    },
    isCompatible(category) {
      const line = this.lineOf(category);
      if (!line || !line.nature || !this.type) return true;
      return line.nature === this.type;
    },
    valueIsCompatible() {
      const category =
        this.categories.find((item) => item.id === this.value) ||
        (this.selected && this.selected.id === this.value
          ? this.selected
          : null);
      return !category || this.isCompatible(category);
    },
    async load() {
      try {
        this.loading = true;
        const params = { active: "true" };
        if (this.scope !== "ULTIMATE") params.companyId = this.scope;
        const response = await CASH.getCategories(params);
        this.categories = response.categories || [];
      } catch (error) {
        console.error(error);
        this.categories = [];
      } finally {
        this.loading = false;
      }
    },
    onCategoryChange(value) {
      this.$emit("input", value || null);
    },
    async apply(categoryId) {
      if (!this.categories.length) await this.load();
      const known = this.categories.some((item) => item.id === categoryId);
      if (known) this.$emit("input", categoryId || null);
    },
  },
  mounted() {
    this.load();
  },
};
</script>
